import { Controller } from "stimulus";

const ACTIVE_SHADOW = "inset 3px 0 0 0 #2684ff";

// Switches between articles.
//
// An article owns more than one pane now (SHP-18715): its fields sit beside the
// list, its regulatory measures below at full width. So a pane is matched by the
// article it belongs to rather than by a single element id, and one click moves
// every pane belonging to that article.
export default class extends Controller {
  static targets = ["link", "pane"];

  connect() {
    this.linkTargets.forEach((link) => {
      if (link.classList.contains("active")) this.highlight(link);
    });
  }

  select(event) {
    event.preventDefault();
    const link = event.currentTarget;

    this.linkTargets.forEach((other) => {
      other.classList.remove("active");
      const row = other.closest(".list-group-item");
      if (row) row.style.boxShadow = "";
    });
    this.paneTargets.forEach((pane) => pane.classList.remove("show", "active"));

    link.classList.add("active");
    this.highlight(link);

    this.panesFor(link.dataset.articleId).forEach((pane) => pane.classList.add("show", "active"));
  }

  panesFor(articleId) {
    return this.paneTargets.filter((pane) => pane.dataset.articleId === articleId);
  }

  highlight(link) {
    const row = link.closest(".list-group-item");
    if (row) row.style.boxShadow = ACTIVE_SHADOW;
  }
}
